import * as mock from "../mockup/mockup";
import axios from "axios";
import { isEdge, isIE, isSafari } from "react-device-detect";
import { sendCustomFavoriteReport } from "../../utils/reporting/customReporting";
import { apiEndPointConstant } from "../../statics/constants";
import { useEffect } from "react";
import { readCache } from "../../utils/readCache";

const getContentById = async (vodId, options) => {
  return await axios.get("/client/content/" + vodId, options);
};

const toggleLikeById = async (vodId) => {
  return await axios.post(`/client/interact/like/` + vodId);
};

const toggleDislikeById = async (vodId) => {
  return await axios.post(`/client/interact/dislike/` + vodId);
};

const toggleFavById = async (vodId) => {
  return await axios.post(`/client/interact/watchlist/` + vodId);
};
const deleteBookmarkById = async (vodId) => {
  return await axios.delete(`/client/interact/` + vodId);
};

const getVodPlayUrlById = async (vodId, currentTime) => {
  if (vodId === undefined || vodId === null || vodId === "") {
    throw new Error("getVodPlayUrlById requires a valid vodId");
  }

  // No position means "open the stream". Sending 0 here would erase an existing
  // resume position before playback starts. An explicit zero remains a save.
  const hasPosition = currentTime !== undefined && currentTime !== null;
  if (hasPosition && (!Number.isFinite(Number(currentTime)) || Number(currentTime) < 0)) {
    throw new Error("Playback position must be a non-negative number");
  }
  const body = hasPosition ? JSON.stringify(Math.floor(Number(currentTime))) : undefined;

  try {
    const response = await axios.post("/client/content/" + vodId + "/watch", body, {
      headers: {
        "Content-Type": "application/json"
      }
    });
    if (response.data?.IsSucceeded === false) {
      throw Object.assign(new Error(response.data.Message || "Playback position could not be saved"), {
        code: response.data.ResultCode
      });
    }
    return response;
  } catch (error) {
    console.error("❌ BOOKMARK API ERROR:", error);
    throw error;
  }
};

const getTrailerPlayUrlById = async (vodId) => {
  return await axios.post("/client/content/" + vodId + "/trailer");
};

const getSearchVods = async (keyword, options) => {
  return await axios.get("/client/search", { ...options, params: { keyword } });
};

const getSearchAutocomplete = async (keyword, limit = 8) => {
  return await axios.get("/search/autocomplete", {
    params: {
      Keyword: keyword,
      Limit: limit
    }
  });
};

const sendPayment = async (vodId, productId, confirmation = {}, type = "RENTAL") => {
  if (type !== "RENTAL") throw new Error("Bu satın alma seçeneği şu anda kullanılamıyor.");
  const response = await axios.post(
    "/client/rentpurchase/" + vodId + "/payment/" + productId,
    {
      QuoteToken: confirmation.QuoteToken,
      PublicationEndAcknowledged: confirmation.PublicationEndAcknowledged === true
    }
  );
  if (response.data?.IsSucceeded !== true) {
    throw Object.assign(new Error(response.data?.Message || "Payment failed"), { code: response.data?.ResultCode });
  }
  readCache.clear();
  return { ...response, data: response.data.Data };
};

const completeContent = id => {
  if (!id) return Promise.reject(new Error("Content is required"));
  return axios.post(`/client/content/${id}/complete`, { completed: true });
};

const getMainboards = async (bannerPosition) => {
  let apiEndpoint = localStorage.getItem("interfaceurl");
  return await axios.get(`${apiEndpoint}/sdk_getbannerlist.jsp`, {
    params: { bannerposition: bannerPosition }
  });
};

const getMainboardsMockup = async () => {
  return await new Promise((resolve, reject) => {
    setTimeout(() => resolve(mock.mainboards), 300);
  });
};

const getVodsByLabel = async (id, page, size, options) => {
  return await axios.get("/client/label/" + id, {
    ...options,
    params: { page: page, size: size }
  });
};

const getRecommendData = async (columnCode) => {
  var apiEndpoint = localStorage.getItem("interfaceurl");
  var sessiondId = localStorage.getItem("sessionid");
  return await axios.get(`${apiEndpoint}/getrecommenddata.jsp`, {
    params: {
      columncode: columnCode,
      contenttype: "1,14",
      pageno: 1,
      numberpage: 200
    }
  });
};

const getFavList = async (favType, columnCode) => {
  var apiEndpoint = localStorage.getItem("interfaceurl");
  var sessiondId = localStorage.getItem("sessionid");
  return await axios.post(
    `${apiEndpoint}/sdk_getfullfavoritelist.jsp`,
    `favoritetype=${favType}&vodcolumncode=${columnCode}`
  );
};

const getBookmarkedContents = async (columnCode) => {
  var apiEndpoint = localStorage.getItem("interfaceurl");
  var sessiondId = localStorage.getItem("sessionid");
  return await axios.get(`${apiEndpoint}/sdk_getfullbookmarklist.jsp`, {
    params: {
      vodcolumncode: columnCode,
      bookmarktype: "1,4,19"
    }
  });
};

const getVodDetail = async (programCode) => {
  var apiEndpoint = localStorage.getItem("interfaceurl");
  var sessiondId = localStorage.getItem("sessionid");
  return await axios.get(`${apiEndpoint}/sdk_getvoddetail.jsp`, {
    params: {
      programcode: programCode,
      isquerytrailer: 1,
      isquerybookmark: 1,
      ischecksubscribe: 1
    }
  });
};

const getSerieDetail = async (programCode, contentCode) => {
  var apiEndpoint = localStorage.getItem("interfaceurl");
  var sessiondId = localStorage.getItem("sessionid");
  return await axios.get(`${apiEndpoint}/sdk_getvodinfo.jsp`, {
    params: {
      programcode: programCode,
      contentcode: contentCode
    }
  });
};

const getSeasons = async (programCode) => {
  var apiEndpoint = localStorage.getItem("interfaceurl");
  var sessiondId = localStorage.getItem("sessionid");
  return await axios.get(`${apiEndpoint}/sdk_getserieschildlist.jsp`, {
    params: {
      seriesprogramcode: programCode,
      seriestype: 3,
      pageno: 1,
      numperpage: 500
    }
  });
};

const getVodPlayUrl = async (programCode, columnCode) => {
  var apiEndpoint = localStorage.getItem("interfaceurl");
  var sessiondId = localStorage.getItem("sessionid");
  return await axios.get(`${apiEndpoint}/sdk_getvodurl.jsp`, {
    params: {
      programcode: programCode,
      columncode: columnCode,
      urlredirect: 1
    }
  });
};

const getSearchKeyword = async (term) => {
  let apiEndpoint = localStorage.getItem("interfaceurl");
  return await axios.post(
    `${apiEndpoint}/sdk_getkeywordsearch.jsp`,
    `condition=${decodeURIComponent(
      term
    )}&conditiontype=16|17|18|19&searchtype=2&sorttype=0&pageno=1&numperpage=10`
  );
};

const getSearchResult = async (
  term,
  userLevel,
  contentTypes,
  subType,
  page,
  columnCodes
) => {
  let apiEndpoint = localStorage.getItem("interfaceurl");
  return await axios.post(
    `${apiEndpoint}/getsearchdata.jsp`,
    `conditiontype=16|17|18|19|20|21|22&condition=${encodeURIComponent(
      encodeURIComponent(term)
    )}&contenttype=${contentTypes}${
      subType ? `&subtype=${subType}&seriestype=1|3` : ""
    }&filtertype=0|1|2&languagetype=tur|eng&ratingid=${userLevel}&pageno=${page}&numperpage=20&mediaservices=-1|2&columncode=${columnCodes}&contentcode=${columnCodes}`
  );
};

const getUserRatingScore = async (contentCode) => {
  var apiEndpoint = localStorage.getItem("interfaceurl");
  var sessiondId = localStorage.getItem("sessionid");
  return await axios.get(`${apiEndpoint}/sdk_getuserpersonalstaring.jsp`, {
    params: {
      contentcode: contentCode
    }
  });
};

const doRatingVod = async (contentCode, contentType, rating, oldRating) => {
  var apiEndpoint = localStorage.getItem("interfaceurl");
  var sessiondId = localStorage.getItem("sessionid");
  return await axios.get(`${apiEndpoint}/dostarrating.jsp`, {
    params: {
      contentcode: contentCode,
      contenttype: contentType,
      starrating: rating,
      oldstarrating: oldRating
    }
  });
};

const getBannerVodDetail = async (programCodes) => {
  var apiEndpoint = localStorage.getItem("interfaceurl");
  var sessiondId = localStorage.getItem("sessionid");
  return await axios.get(`${apiEndpoint}/sdk_getvodinfo.jsp`, {
    params: {
      programcode: programCodes
    }
  });
};

const getUserTvodPurchaseList = async () => {
  var apiEndpoint = localStorage.getItem("interfaceurl");
  var sessiondId = localStorage.getItem("sessionid");
  return await axios.get(`${apiEndpoint}/sdk_gettvodpurchaselist.jsp`);
};

const getUserEstPurchaseList = async () => {
  var apiEndpoint = localStorage.getItem("interfaceurl");
  var sessiondId = localStorage.getItem("sessionid");
  return await axios.get(`${apiEndpoint}/sdk_getestpurchaselist.jsp`);
};

const sendVideoComplated = async (contentCode, columnCode, programCode) => {
  var apiEndpoint = localStorage.getItem("interfaceurl");
  var sessiondId = localStorage.getItem("sessionid");

  const fullUrl = `${apiEndpoint}/sdk_addcomplete.jsp`;
  const params = {
    contentcode: contentCode,
    columncode: columnCode,
    contentinfo: programCode
  };

  console.log("🚀 COMPLETION API CALL:", {
    url: fullUrl,
    params: params,
    timestamp: new Date().toISOString()
  });

  try {
    const response = await axios.get(fullUrl, { params });
    return response;
  } catch (error) {
    console.error("❌ COMPLETION API ERROR:", error);
    throw error;
  }
};

const getWatchItAgainVodList = async (vodColumnCode) => {
  var apiEndpoint = localStorage.getItem("interfaceurl");
  var sessiondId = localStorage.getItem("sessionid");
  return await axios.get(`${apiEndpoint}/sdk_getuserviewcompletelist.jsp`, {
    params: {
      vodcolumncode: vodColumnCode
    }
  });
};

const getBundleVods = async (productCode) => {
  var apiEndpoint = localStorage.getItem("interfaceurl");
  var sessiondId = localStorage.getItem("sessionid");
  return await axios.get(`${apiEndpoint}/sdk_getmoviebyproduct.jsp`, {
    params: {
      productcode: productCode
    }
  });
};

const getPreviewUrl = async (programCode, columnCode) => {
  var apiEndpoint = localStorage.getItem("interfaceurl");
  return await axios.get(`${apiEndpoint}/sdk_getvodpreviewurl.jsp`, {
    params: {
      programcode: programCode,
      columncode: columnCode,
      urlredirect: "1"
    }
  });
};

const getRecommendationsForVod = async (vodUId, limit = 12) => {
  return await axios.get("/recommendation/for-vod", {
    params: {
      vodUId,
      Limit: limit
    }
  });
};

const getRecommendationsForUser = async (limit = 12) => {
  return await axios.get("/recommendation/for-user", {
    params: {
      Limit: limit
    }
  });
};

const getMostPopularSearchContents = async (limit = 12) => {
  return await axios.get("/recommendation/most-popular", {
    params: {
      Limit: limit
    }
  });
};

const getRecentSearchContents = async (limit = 12) => {
  return await axios.get("/search/recent", {
    params: {
      Limit: limit
    }
  });
};

export {
  completeContent,
  getContentById,
  toggleLikeById,
  toggleDislikeById,
  toggleFavById,
  deleteBookmarkById,
  getVodPlayUrlById,
  getTrailerPlayUrlById,
  getSearchVods,
  getSearchAutocomplete,
  getMainboards,
  sendPayment,
  getSearchResult,
  getVodsByLabel,
  getRecommendData,
  getFavList,
  getBookmarkedContents,
  getVodDetail,
  getVodPlayUrl,
  getSerieDetail,
  getSeasons,
  getSearchKeyword,
  getMainboardsMockup,
  getUserRatingScore,
  doRatingVod,
  getBannerVodDetail,
  getUserEstPurchaseList,
  getUserTvodPurchaseList,
  sendVideoComplated,
  getWatchItAgainVodList,
  getBundleVods,
  getPreviewUrl,
  getRecommendationsForVod,
  getRecommendationsForUser,
  getMostPopularSearchContents,
  getRecentSearchContents
};
